<script>
export default {
  data() {
    return {};
  },
};
</script>

<template>
  <div class="v-carousel-item">
    <slot />
  </div>
</template>

<style lang="scss">
.v-carousel-item {
  width: 100%;
  float: left;
  min-width: calc(100vw - 30px);
  text-align: center;
}
@media (min-width: 650px) {
  .v-carousel-item {
    width: 100%;
    max-width: 620px;
    min-width: 0px;
    float: left;
    text-align: center;
  }
}
</style>
